import { apiClient } from '../../config/axios.config'; // Adjust the import path as necessary

import {
  BASE_AUTOCOMPLETE_URL,
  BASE_REASSIGN_APPROVAL_URL,
  BASE_URL,
} from '../apiConfig';

export const fetchRequestTypeList = async () => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_REASSIGN_APPROVAL_URL}/request-type-list`,
  );
  return response?.data;
};

export const fetchRequesterList = async () => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_REASSIGN_APPROVAL_URL}/requester-list`,
  );
  return response?.data;
};

export const fetchReassignApprovals = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_REASSIGN_APPROVAL_URL}/search-approvals`,
    payload,
  );
  return response;
};

export const fetchTableColumnValues = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_AUTOCOMPLETE_URL}/get-table-column-values`,
    payload,
  );
  return response;
};

export const cancelRequest = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_REASSIGN_APPROVAL_URL}/cancel-request`,
    payload,
  );
  return response;
};

export const approveRejectRequest = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_REASSIGN_APPROVAL_URL}/approve-reject-request`,
    payload,
  );
  return response;
};

export const approveRejectRequestList = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_REASSIGN_APPROVAL_URL}/approve-reject-request/list`,
    payload,
  );
  return response;
};

export const cancelRequestList = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_REASSIGN_APPROVAL_URL}/cancel-request/list`,
    payload,
  );
  return response;
};

export const getMyapprovalsRequestCount = async () => {
  const response = await apiClient.get(
    `${BASE_URL}${BASE_REASSIGN_APPROVAL_URL}/my-approvals-requests/count`,
  );
  return response;
};

export const updateReassignApproval = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_REASSIGN_APPROVAL_URL}/update-approvals`,
    payload,
  );
  return response;
};
